
import { defineComponent, ref } from 'vue';

import FormularioMotorista from "./forms/motoristas/FormularioMotorista.vue";

import RowsTable from "./components/MotoristasTable.vue";

import moment from 'moment';

import fintailapi from "../api";

import { useToast } from "vue-toastification";
import Veiculos from './Veiculos.vue';

export default defineComponent({
  name: "tables",
  components: {
    FormularioMotorista,
    RowsTable
  },
  data() {
    return {
      rows: [],
      operacoes:[],
      veiculos:[],
      motorista:{id:"-",data_nascimento:"01/01/1900"},
      current_page: 0,
      total_count: 0,
      total_pages: 0, 
      toast : useToast()
    };
  },
  methods: {
    getOperacoes(offset:number) {

      fintailapi
      .get(`/operacoes?offset=${offset}&limit=100`)
      .then((response:any) => {
        this.operacoes = response.data.rows

        this. getVeiculos(0)

      })
      .catch((error:any) => {

      })

    },  
    getVeiculos(offset:number) {

        fintailapi
        .get(`/veiculos?offset=${offset}&limit=200`)
        .then((response:any) => {

          this.current_page = offset;
          this.total_count = response.data.count
          this.total_pages =  Math.ceil(response.data.count / 10);
          this.veiculos = response.data.rows

      
        
        })
        .catch((error:any) => {

        })

    },
    getUnico(id:any) {

      fintailapi
        .get(`/transportadores/${id}`)
        .then((response:any) => {
          this.motorista = response.data
          this.motorista.data_nascimento = moment(this.motorista.data_nascimento , "YYYY-MM-DD").format("DD/MM/YYYY");
        })
        .catch((error:any) => {

        })
    },
    salvarUnico(motorista:any) {

 
      if(motorista.data_nascimento)motorista.data_nascimento = moment(motorista.data_nascimento, "DD/MM/YYYY").format("YYYY-MM-DD");

      if(motorista.id != '' && motorista.id != undefined){

          fintailapi
          .put(`/transportadores/${motorista.id}`, motorista)
          .then((response:any) => {
            
            this.motorista.id = "-"
            this.getPaginas(0)

          })
          .catch((error:any) => { })

      }else{

        motorista.id = undefined
        motorista.tipo = "motorista"

          fintailapi
          .post(`/transportadores`, motorista)
          .then((response:any) => {
            
            this.motorista.id = "-"
            this.getPaginas(0)

          })
          .catch((error:any) => {  })

      }

    },

    deleteUnico(id:any) {
      fintailapi
        .delete(`/transportadores/${id}`)
        .then((response:any) => {

          this.toast.success("Usuário excluído com sucesso");
          this.getPaginas(0)

        })
        .catch((error:any) => {
          this.toast.error("Erro ao excluir Usuário, tente novamente.");
        })
    },
    fecharUnico() {

        this.motorista.id = "-"

    },
    getPaginas(offset:number) {

        fintailapi
        .get(`/transportadores?offset=${offset}&limit=10`)
        .then((response:any) => {

          this.current_page = offset;

          this.total_count = response.data.count
          this.total_pages =  Math.ceil(response.data.count / 10);
         
          this.rows = response.data.rows


          this.getOperacoes(0)
        
        })
        .catch((error:any) => {



        })

    },
   },
   created() {
    
      let modo = this.$route.params.id ||'view';

      if(modo=="criar"){
        this.motorista.id = ""
      }

      this.getPaginas(0)


   },

});


